import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const RadioButtonCheck = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 50%;
  box-sizing: border-box;

  &:after {
    content: '';
    display: ${({ checked }) => (checked && 'block') || 'none'};
    width: 11px;
    height: 11px;
    background-color: ${({ theme }) => theme.colors.blueMain};
    border-radius: 50%;
  }
`;

export const RadioButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 16px;
  background-color: ${({ theme, checked }) =>
    (checked && theme.colors.blueLight) || theme.colors.white};
  border: 1px solid
    ${({ theme, checked }) => (checked && theme.colors.blueMain) || theme.colors.grey003};
  border-radius: 8px;
  cursor: pointer;

  & > * + * {
    margin-inline-start: 12px !important;
  }

  & ${RadioButtonCheck} {
    border: 1px solid
      ${({ theme, checked }) => (checked && theme.colors.blueMain) || theme.colors.grey006};

    &:after {
      display: ${({ checked }) => (checked && 'block') || 'none'};
    }
  }
`;

export const RadioButtonLabel = styled(typography.P2RegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey600};
`;
